module.exports = __webpack_public_path__ + "static/8-552bd0349d40478ae8ad82c471003cc4.jpg";